import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { ValidationContext } from '../../providers/ValidationContext';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function ContinueScreen(): JSX.Element {
  const navigate = useNavigate();
  const { initialized } = useContext(FlowConfigContext);
  const { getRouteForNextStep } = useContext(ValidationContext);

  const handleConfirm = async () => {
    const route = await getRouteForNextStep();
    if (route) navigate(route);
  };

  return (
    <MessagePanel
      title="screens.continue.title"
      description="screens.continue.description"
      buttonLabel="screens.continue.buttonLabel"
      dataTestId="CONTINUE_SCREEN"
      onConfirm={handleConfirm}
      loading={!initialized}
      showSupportLink={false}
    />
  );
}
export default withRouteAnalytics(ContinueScreen, Screens.CONTINUE);
